module.exports = __webpack_public_path__ + "static/media/kk-i_sports.689c8775.png";